<template>
  <div class="wrap">
    <div class="title">
      在线的cnptOS工业云服务
    </div>
    <div class="box">
      <div class="item-wrap">
        <div class="item" v-for="i in list" :key="i.name">
          <div>
            <img class="item-img" :src="i.icon" alt="" />
            <p class="text">{{ i.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "CloudService",
    components: {},
    data() {
      return {
        list: [
          {
            name: "开箱即用",
            icon: require("@/assets/images/images/icon_OOTB.svg"),
          },
          {
            name: "按需付费",
            icon: require("@/assets/images/images/icon_pay_for_use.svg"),
          },
          {
            name: "弹性伸缩",
            icon: require("@/assets/images/images/icon_aotu.svg"),
          },
          {
            name: "零运维",
            icon: require("@/assets/images/images/icon_zero.svg"),
          },
          {
            name: "随时随地管理生产运营",
            icon: require("@/assets/images/images/icon_anywhere.svg"),
          },
          {
            name: "企业无需自建IDC机房",
            icon: require("@/assets/images/images/icon_dic.svg"),
          },
          {
            name: "有效降低TCO",
            icon: require("@/assets/images/images/icon_lower.svg"),
          },
          {
            name: "快速投入生产",
            icon: require("@/assets/images/images/icon_fast.svg"),
          },
        ],
      };
    },
    created() {},
    mounted() {},
    computed: {},
    watch: {},
    methods: {},
  };
</script>
<style scoped>
  .wrap {
    /* background-color: #eceef3; */
    min-height: 675px;
    text-align: center;
    /* margin-top: 60px; */
  }
  .title {
    font-size: 28px;
    color: #212224;
    letter-spacing: 0;
    text-align: center;
    padding-top: 80px;
    margin-bottom: 50px;
  }
  .item-wrap {
    width: 1077px;
    display: flex;
    flex-flow: row wrap;
    margin: 0 auto;
    background: #eceef3;
    border-left: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
  }
  .item {
    width: 269px;
    height: 200px;
    box-sizing: border-box;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
  }
  .item-img {
    width: 60px;
    height: 60px;
    margin-top: 38px;
  }
  .text {
    width: 97px;
    font-size: 16px;
    color: #212224;
    letter-spacing: 0.12px;
    text-align: center;
    margin: 30px auto 0px;
  }
</style>
